import React, { useState, useEffect } from 'react';
import { refreshAccessToken, logout, AuthControl } from "./auth";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Navbar from "./NavBar";
function IzinOnay() {
  const [izinler, setIzinler] = useState([]);
  const [user, setuser]=useState(null);
  const [loading, setLoading]=useState(true);
  const [error,setError] =useState(null);
  const navigate = useNavigate();
  //const server_URL = `http://192.168.2.250:50`;
  // Fetch undecided leave requests
  const fetchIzinler = async (user) => {
    try {
      if (!user) {
        console.error("SICIL bilgisi lokalde bulunamadı");
        return;
    }else {
      console.log("user verified (izin_onay)");
    }
      
      const response = await fetch(`/izin_onay/${user.sicil_no}`);
      const data = await response.json();
      if (!response.ok) 
        {
          setIzinler([]);
          setError(data.error||'Veriler alınamadı!');
          await AuthControl(response,navigate);
          return;
        }
      else setError(null);
      //const data = await response.json();
      console.log("data:",data);
      console.log(error);
      setIzinler(data);
    } catch (error) {
      console.error('Hata:', error);
      setError('Sistem hatası. Lütfen sonra tekrar deneyiniz');
    }
  };
  
  useEffect(() => {
    async function init() {
      const success = await refreshAccessToken();
      if (!success) {
        console.log('Refresh failed, redirected to login.');
        return;
      }
  
      try {
        const res = await fetch('/me', { credentials: 'include' });
        const data = await res.json();
        if (res.ok) {
          if (data.sicil_no) {
            //setFormData((prevData) => ({ ...prevData, SICIL_NO: data.SICIL_NO }));
            setuser(data);
            fetchIzinler(data);
            setLoading(false);
          } else {
                    console.error("Sicil bilgisi bulunamadı");
                    alert("Kullanıcı bilgilerinin yeniden girilmesi gerekiyor.");
                  logout();
                  }
                } else {
                  console.error("User fetch error:", data.error);
                  alert("Kullanıcı bilgilerinin yeniden girilmesi gerekiyor.");
                  logout();
                }
              } catch (err) {
                console.error("User fetch exception:", err);
                alert("Kullanıcı bilgilerinin yeniden girilmesi gerekiyor.");
                logout();
              }
    }
  
    init();
  }, []);

  // izin onayla/redddet
  const handleOnay = async (id, onayDurumu) => {
    setLoading(true); 
    const actionText = onayDurumu === 1 ? "onaylamak" : "reddetmek";
  
    const confirmAction = window.confirm(`Bu izni ${actionText} istediğinize emin misiniz?`);
    if (!confirmAction) return;
    setLoading(true); 
    try {
      const response = await fetch(`/izin_karar/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ onay: onayDurumu })
      });
  
      if (!response.ok) throw new Error('Güncelleme başarısız!');
      else window.alert("Karar kaydedildi.");
  
      // Refresh the list
      fetchIzinler(user);//setIzinler(izinler.filter(izin => izin.id !== id));
      setLoading(false);
    } catch (error) {
      console.error('Hata:', error);
    }
  };
 

  return (
    <div>
   
    <div className="container">
       <Navbar />
      <h1>Onay Bekleyen İzin Talepleri</h1>
      {error?(<p>{error}</p>):(
        <div className="table_wrapper">
      <table>
        <thead>
          <tr>
            <th>Personel</th>
            <th>İzin Türü</th>
            <th>Başlangıç</th>
            <th>Bitiş</th>
            <th>Talep Edilen Gün</th>
            <th>Açıklama/Gerekçe</th>
            <th>Kayıt Tarihi</th>
            <th>İşlem</th>
          </tr>
        </thead>
        <tbody>
          {izinler.map((izin) => (
            <tr key={izin.ID}>
              <td>{izin.ADI_SOYADI}</td>
              <td>{izin.IZIN_TUR_AD}</td>
              <td>{new Date(izin.BASLANGIC_TARIH).toLocaleString()}</td>
              <td>{new Date(izin.BITIS_TARIH).toLocaleString()}</td>
              <td>{izin.TALEP_GUN}</td>
              <td>{izin.ACIKLAMA}</td>
              <td>{new Date(izin.KAYIT_TARIHI).toLocaleString()}</td>
              <td>
                <button disabled={loading} onClick={() => handleOnay(izin.ID, 1)}>✔️ Onayla</button>
                <button disabled={loading} onClick={() => handleOnay(izin.ID, 0)}>❌ Reddet</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table></div>)}
    </div>
    </div>
  );
}

export default IzinOnay;
